/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndividualRunTaskSchema
 */
export interface IndividualRunTaskSchema {
    /**
     * 
     * @type {number}
     * @memberof IndividualRunTaskSchema
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof IndividualRunTaskSchema
     */
    arrayTaskId: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IndividualRunTaskSchema
     */
    envVars?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IndividualRunTaskSchema interface.
 */
export function instanceOfIndividualRunTaskSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "taskId" in value;
    isInstance = isInstance && "arrayTaskId" in value;

    return isInstance;
}

export function IndividualRunTaskSchemaFromJSON(json: any): IndividualRunTaskSchema {
    return IndividualRunTaskSchemaFromJSONTyped(json, false);
}

export function IndividualRunTaskSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualRunTaskSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskId': json['task_id'],
        'arrayTaskId': json['array_task_id'],
        'envVars': !exists(json, 'env_vars') ? undefined : json['env_vars'],
    };
}

export function IndividualRunTaskSchemaToJSON(value?: IndividualRunTaskSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_id': value.taskId,
        'array_task_id': value.arrayTaskId,
        'env_vars': value.envVars,
    };
}

